import { BaseApi, type PaginatedResponse, type RequestParams } from '@bv/api';

import { ProductType } from '../types/template';
class ProductsApi extends BaseApi {
  constructor() {
    super('conversations/products/catalog');
  }

  public async get(params?: RequestParams): Promise<{ data: PaginatedResponse<ProductType> }> {
    return this.request({
      method: 'get',
      url: 'items',
      params,
    });
  }
}

export default new ProductsApi();
